export const clearState = (initialState) => {
  return (state) => {
    Object.keys(initialState).forEach((key) => {
      state[key] = initialState[key]
    })
  }
}
